import styled from 'styled-components'

import theme from 'theme_'
import { Form } from 'formik'
import { CommonButton } from 'components/Button'
import { TextField } from 'components/Fields'

export const StyledPromocodeForm = styled(Form)`
  display: flex;

  @media ${theme.devices.tabletLandscape} {
    margin-top: 12px;

    button {
      margin-left: ${theme.spacing.md};
      width: 150px;
    }
  }
`

export const StyledPromocodeInputWrap = styled.div`
  flex-grow: 2;

  input {
    width: 100%;
  }
`
export const StyledApplyPromocodeBtn = styled(CommonButton)`
  height: 40px;
  width: 100px;
  margin-left: 16px;
`

export const StyledPromocodeApplied = styled.span`
  color: ${theme.colors.error};
`

export const StyledPromocodeField = styled(TextField)``
